(function () {
    'use strict';

    // @ngInject
    function SplashScreenServiceCtor($, $q) {
        this.splashScreenElm = $('#splash-screen');
        this.splashScreenElmHB = $('#splash-screen-hb');
        this.$q = $q;
    }

    Services.SplashScreenService = Class({
        constructor: SplashScreenServiceCtor,

        hide() {
            return this._fadePromise('fadeOut', this.splashScreenElm);
        },

        show() {
            return this._fadePromise('fadeIn', this.splashScreenElm);
        },

        hideHB() {
            return this._fadePromise('fadeOut', this.splashScreenElmHB);
        },

        showHB() {
            return this._fadePromise('fadeIn', this.splashScreenElmHB);
        },

        _fadePromise(type, loader) {
            let defer = this.$q.defer();
            loader[type](400, () => defer.resolve() );
            return defer.promise;
        }

    });
}());
